import {defineStore} from 'pinia';
// import {useKioskStore} from './kiosk-store';
import {useBasketStore} from './basket-store';

export const useCashierStore = defineStore('cashier', {
	state: () => ({
		interval: null
	}),
	actions: {
		startTimer() {
			console.log('cashier-store.js: Start timer');

			if(this.interval !== null) {
				clearInterval(this.interval)
			}
			// useBasketStore().getKioskStatus();
			this.interval = setInterval(() => {
				useBasketStore().getKioskStatus();
			}, 1000);

		},
		stopTimer() {
			console.log('cashier-store.js: Stop timer');

			clearInterval(this.interval)
		},
	}
});
